import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  colors: {
    chalk: {
      50: '#FFFFFF',
      100: '#F9FAF5',
      200: '#F1F4E9',
      300: '#EEF2E1',
      400: '#E2E7D3',
      500: '#D2D9C1',
    },
    lime: {
      300: '#C8F284',
      400: '#B6EE55',
      500: '#9FE23A',
      600: '#7FC220',
      700: '#649619',
    },
    ink: {
      900: '#14251A',
      800: '#1C2B20',
      700: '#26362A',
    },
    slate: {
      700: '#3F4238',
      500: '#6B6F62',
      400: '#8B8F80',
    },
    // Wobble's real brand palette (pulled from wobble.hu's own Chakra
    // theme tokens --chakra-colors-brand-1/2/3) — used on the Wobble
    // product section so it reads as the actual product's colors instead
    // of a Miller Productions-lime reskin of it.
    wobble: {
      700: '#024856',
      600: '#007188',
      400: '#5AB3C5',
      200: '#BFE0E7',
      100: '#E9F0F1',
      50: '#F5F9FA',
    },
    // BOB's real in-app palette (dark navy sidebar + teal accent, matched
    // against actual product screenshots) — used only on the /bob page so
    // its product demo reads as the real app, not a Miller Productions-lime
    // reskin of it. 900/800/300 are the exact colors from the app; the
    // lighter tints are derived from the accent for light-background pill
    // fills, which the app itself doesn't need since its chrome is dark.
    bob: {
      900: '#171c26',
      800: '#1d2330',
      300: '#14b8a6',
      200: '#5eead4',
      100: '#ccfbf1',
      50: '#f0fdfa',
    },
    // Rosa's in-app palette (indigo/violet accent on a light support-inbox
    // UI, matched against real product screenshots) — used on the Rosa
    // section so its preview reads as the actual product, not a Miller
    // Productions-lime reskin of it.
    rosa: {
      700: '#4C1D95',
      600: '#6D28D9',
      500: '#6366F1',
      200: '#C7D2FE',
      100: '#E0E7FF',
      50: '#F5F3FF',
    },
  },
  fonts: {
    heading: `'Poppins', -apple-system, BlinkMacSystemFont, sans-serif`,
    body: `'Poppins', -apple-system, BlinkMacSystemFont, sans-serif`,
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'full',
      },
    },
  },
  styles: {
    global: {
      html: {
        scrollBehavior: 'smooth',
      },
      body: {
        bg: 'chalk.100',
        color: 'ink.900',
      },
      '::selection': {
        background: '#9FE23A',
        color: '#14251A',
      },
    },
  },
})

// BOB's own theme, scoped to the /bob page only (mounted via a nested
// ChakraProvider in BobPage.tsx). Same color tokens as the base theme —
// `bob.*` already carries the real app's navy/teal palette — but swaps
// body copy to Lato (BOB's own typeface) while keeping Poppins for
// headings, so /bob reads as its own product rather than a Miller
// Productions page with a teal accent bolted on.
export const bobTheme = extendTheme(theme, {
  fonts: {
    heading: `'Poppins', -apple-system, BlinkMacSystemFont, sans-serif`,
    body: `'Lato', -apple-system, BlinkMacSystemFont, sans-serif`,
  },
  styles: {
    global: {
      html: {
        scrollBehavior: 'smooth',
      },
      body: {
        bg: 'chalk.100',
        color: 'ink.900',
      },
      '::selection': {
        background: '#14b8a6',
        color: '#f0fdfa',
      },
    },
  },
})

export default theme
